module.exports = __webpack_public_path__ + "img/arrows-locked.d71d4256.svg";